/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ model: NonNullable<unknown>, ms: NonNullable<unknown> }} Ai_Test_OkInputs */

const en_ai_test_ok = /** @type {(inputs: Ai_Test_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connected · ${i?.model} · ${i?.ms} ms`)
};

const de_ai_test_ok = /** @type {(inputs: Ai_Test_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verbunden · ${i?.model} · ${i?.ms} ms`)
};

/**
* | output |
* | --- |
* | "Connected · {model} · {ms} ms" |
*
* @param {Ai_Test_OkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_test_ok = /** @type {((inputs: Ai_Test_OkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Test_OkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_test_ok(inputs)
	return en_ai_test_ok(inputs)
});